<template>
  <div :id="id" class="modal fade" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-pdf">
      <div class="modal-content">
        <div class="modal-header">
          <modal-close-button-new @confirmed="close" />
          <h4 class="modal-title">{{ $t("global.importfile") }}</h4>
        </div>
        <div class="modal-body">
          <div class="col-xl-12">
            <div class="form-group text-center">
              <vue-2-dropzone
                id="dropzone"
                ref="dokumenteUpload"
                class="dropzone-white dropzone-small vue-dropzone dropzone dz-clickable"
                :options="dropzoneOptions"
                @vdropzone-success="fileUploaded"
              ></vue-2-dropzone>
              <button class="btn btn-primary mt-2" @click="uploadFiles">
                {{ $t("global.upload") }}
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" @click="close">
            {{ $t("global.close") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { modal } from "@/mixins/Modal";
import store from "@/store";
import Api from "@/api/Api";
import vue2Dropzone from "vue2-dropzone";
import { dropzoneOptionsFile } from "@/config/Dropzone";
import ModalCloseButtonNew from "@/components/global/ModalCloseButtonNew.vue";

export default {
  name: "FileUploadModal",
  components: {
    vue2Dropzone,
    ModalCloseButtonNew,
  },
  mixins: [modal],
  store,
  props: [
    "id",
    "person",
    "foreigntable",
    "foreignkey",
    "gptyp",
    "aktivitaet",
    "auftrag",
  ],
  data() {
    return {
      numPages: 1,
      actualPage: 1,
      dropzoneOptions: dropzoneOptionsFile(
        Api.defaults.baseURL,
        this.person,
        this.foreigntable,
        this.foreignkey,
        this.gptyp,
        this.aktivitaet,
        this.auftrag
      ),
    };
  },
  computed: {},
  methods: {
    close() {
      $(`#${this.id}`).modal("hide");
    },
    uploadFiles() {
      this.$refs.dokumenteUpload.processQueue();
    },
    fileUploaded() {
      $(`#${this.id}`).modal("hide");
      this.$parent.getDokumente(true);
    },
  },
};
</script>

<style>
</style>
